import { useTranslation } from 'react-i18next';
import type { UnitsNoticeProps } from './UnitsNotice.types';
import styles from './unitsNotice.module.css';

/**
 * Why a stepper stopped, or what is still missing, above the unit steppers —
 * "at least 2 people", "maximum reached".
 */
const UnitsNotice = ({ message }: UnitsNoticeProps) => {
  const { t } = useTranslation();
  return <p className={styles.notice}>{t(message.key, message.values)}</p>;
};

export default UnitsNotice;
